import * as React from 'react';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { DataBsqPersonal, parseFechaCadena } from '../../interfaces/DataBsqProy';
import {HiOutlineDocumentSearch} from 'react-icons/hi';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent} from '@mui/material';
import {format} from 'date-fns';
import * as XLSX from 'xlsx';
import AlertService from '../../services/AlertService';
import ProyectoService from '../../services/ProyectoService';
import { DetalleProyectoModal } from './DetalleProyecto';
import { ProyectoPorUsuario, getVoidProyectoPorUsuario } from '../../interfaces/BusquedaPersonalDTO';
import { DetallesProyecto, getVoidDetallesProyecto } from '../../interfaces/DetallesProyecto';

interface Column {
  id: 'code' | 'title' | 'director' | 'inicio' | 'fin' | 'estado' | 'opcions';
  label: string;
  minWidth?: number;
  align?: 'right';
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: 'code', label: 'Identificación', minWidth: 170 },
  { id: 'title', label: 'Usuario', minWidth: 100 },
  { id: 'director', label: 'Rol', minWidth: 110},
  {
    id: 'inicio',
    label: 'Inicio',
    minWidth: 85,
  },
  {
    id: 'fin',
    label: 'Fin',
    minWidth: 85,
  },
  {
    id: 'estado',
    label: 'Proyecto',
    minWidth: 170,
  },
  {
    id: 'opcions',
    label: 'Opciones',
    minWidth: 120,
  },
];

interface Data {
  name: string;
  code: string;
  population: number;
  size: number;
  density: number;
}

function createData(
  name: string,
  code: string,
  population: number,
  size: number,
): Data {
  const density = population / size;
  return { name, code, population, size, density };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const proyectoService = new ProyectoService();
const alertService = new AlertService();

export default function BusqPersonalTable(props: DataBsqPersonal) {
  let history = useNavigate()
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(props.rowsPerPage[0]);
  const [open, setOpen] = React.useState(false);
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
  const [modalData, setModalData] = React.useState<ProyectoPorUsuario>(getVoidProyectoPorUsuario());
  const [detalleData, setDetalleData] = React.useState<DetallesProyecto>(getVoidDetallesProyecto());

  const handleOpenModal = async (data: ProyectoPorUsuario) => {
    await handleSearchDetalle(data.iddecinvproyecto);
    setModalData(data);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const options = [
    { value: 'D', label: 'Firma Decano' },
    { value: 'DS', label: 'Firma Decano Subrrogante' },
  ];
  const [autoridad,setAutoridad] = React.useState('D');

  const handleChange = (event: SelectChangeEvent) => {
    setAutoridad(event.target.value as string);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const descargarArchivoExcel = () => {
    try {
      // Decodificar la cadena base64 a un array de bytes
      const byteCharacters = atob(props.archivo);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      // Crear un blob con el array de bytes
      const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      // Crear una URL para el blob y generar el enlace de descarga
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'ReportePersonal.xlsx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al descargar el archivo Excel', error);
    }
  };

  const generarCertificado = () => {
    const cedula = props.data[0].cedula;
    alertService.showLoading("Generando...");
    try {
      handleClose();
      proyectoService.GenerarCertificadoParticipacion(cedula,props.iduser,autoridad,props.token)
      .then((data) => {
        //console.log(data)
        if(data.strEstado === 'S'){
          alertService.hideLoading();
          window.open(data.objDatos, '_blank');
        }else{
          alertService.hideLoading();
          alertService.alertaAdvertencia('ATENCIÓN',data.strMensaje);
        }
        
      })
      .catch((error) => {
        console.error(error);
        alertService.hideLoading();
        alertService.alertaAdvertencia('ATENCIÓN','Ocurrio un problema al momento de generar al certificado.');
      })
    } catch (error) {
      console.error('Error al generar el archivo', error);
      alertService.hideLoading();
      alertService.alertaAdvertencia('ATENCIÓN','Ocurrio un problema al momento de generar al certificado.');
    }
  };

  const handleSearchDetalle = async (id:number) =>{
    try{
      await proyectoService.GetDetalleProyectoById(id,props.token)
              .then((data) => {
                  //console.log(data);
                  setDetalleData(data.data);
              })
              .catch((error) => {
                console.error(error)
              });
    }catch(error){
      console.error('Error:',error);
    }
   };

  const goToNavigation = (site:string) =>{
    history(site)
  }

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <Grid container spacing={2} sx={{marginBottom:2}}>
        <Grid item xs={12} sm={12} md={4} lg={4}>
         <Button variant='contained' onClick={descargarArchivoExcel} disabled={props.archivo.length === 0}>Descargar</Button>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
        <Grid item xs={12} sm={12} md={4} lg={4} container justifyContent="flex-end">
         <Button variant='contained' onClick={handleClickOpen} disabled={props.archivo.length === 0}>Certificado</Button>
        </Grid>
       </Grid>
        <TableContainer sx={{ maxHeight: 600 }}>
            <Table stickyHeader aria-label="sticky table">
            <TableHead>
                <TableRow>
                {columns.map((column) => (                
                    <StyledTableCell 
                        style={{ minWidth: column.minWidth }}
                        key={column.id}
                        align={column.align}>
                    {column.label}
                    </StyledTableCell>
                ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {props.data.length > 0 ? props.data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                    return (
                    <StyledTableRow key={row.iddecinvproyecto}>
                <StyledTableCell component="th" scope="row">
                    {row.cedula}
                </StyledTableCell>
                <StyledTableCell align="left">{row.nombrecolaborador}</StyledTableCell>
                <StyledTableCell align="left">{row.nombrerol}</StyledTableCell>
                <StyledTableCell align="left">{row.fechainicio !== null ? parseFechaCadena(row.fechainicio?.toString()) : ''}</StyledTableCell>
                <StyledTableCell align="left">{row.fechafin !== null ? parseFechaCadena(row.fechafin?.toString()) : ''}</StyledTableCell>
                <StyledTableCell align="left">{row.tituloproyecto}</StyledTableCell>
                <StyledTableCell align="left">
                    <Button variant="contained" endIcon={<HiOutlineDocumentSearch />} onClick={() => handleOpenModal(row)} >Detalle</Button>
                </StyledTableCell>
                </StyledTableRow>
                    );
                }):
                <StyledTableRow key={0}>
                <StyledTableCell component="th" scope="row">
                    {'9999999999'}
                </StyledTableCell>
                <StyledTableCell align="left">{''}</StyledTableCell>
                <StyledTableCell align="left">{''}</StyledTableCell>
                <StyledTableCell align="left">{format(new Date(),'dd/MMM/yyyy')}</StyledTableCell>
                <StyledTableCell align="left">{format(new Date(),'dd/MMM/yyyy')}</StyledTableCell>
                <StyledTableCell align="left">{''}</StyledTableCell>
                <StyledTableCell align="left"></StyledTableCell>
                </StyledTableRow>
                }
            </TableBody>
            </Table>
        </TableContainer>
        <TablePagination
            rowsPerPageOptions={props.rowsPerPage}
            component="div"
            count={props.data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
        <Dialog onClose={handleClose} open={open}>
          <DialogTitle>Generar Certificado</DialogTitle>
          <DialogContent>
          <DialogContentText>
            ¿Quien desea que sea la firma en el certificado?
          </DialogContentText>
          <FormControl fullWidth >
          <InputLabel id="label-simple-select">Autoridad</InputLabel>
          <Select
            labelId="label-simple-select"
            id="simple-select"
            value={autoridad}
            label="Autoridad"
            onChange={handleChange}
          >
            {options.map((op) => (
              <MenuItem value={op.value}>{op.label}</MenuItem>
            ))}
          </Select>
          </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cerrar</Button>
            <Button onClick={generarCertificado}>Generar</Button>
          </DialogActions>
        </Dialog>
        <DetalleProyectoModal isOpen={isModalOpen} onClose={handleCloseModal} data={modalData} detalle={detalleData}/>
    </Paper>
  );
}